import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted, computed } from "vue"

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'AppEditorWindow',
  props: {
  isOpen: { type: Boolean, default: true },
  default: { type: String, required: true },
  title: { type: String, required: true },
  version: { type: String, default: "v2" },
  app: { type: String, default: "Scope Editor" },
  pages: { type: Array as () => string[], required: true },
  showAppVersion: { type: Boolean, default: true },
},
  emits: ["change", "close"],
  setup(__props, { expose, emit }) {

const props = __props



// Emits


// Refs
const next = ref("Next")
const _next = computed(() => {
  if (props.pages.length === 1) return "Close"
  return next.value
})

const back = ref("Back")
const _back = computed(() => {
  if (props.pages.length === 1) return null
  return back.value
})

const saved = ref(false)
const saving = ref(false)
const page = ref<string | null>(null)
let _timeout: number | undefined

// Methods
const save = () => {
  saved.value = true
  saving.value = false

  clearTimeout(_timeout)

  _timeout = window.setTimeout(() => {
    saved.value = false
  }, 4000)
}

const applySaving = (value = true) => {
  saving.value = value
}

expose({
  save,
  applySaving,
})

const changePage = (page: string | null) => {
  emit("change", page)
}

const pageIndex = () => {
  return props.pages.findIndex((p) => p === page.value)!
}

const onChangePage = (direction: string) => {
  const index = pageIndex()

  if (direction === "right") {
    if (index === props.pages.length - 1) return onClose()
    page.value = props.pages[index + 1]
  }

  if (direction === "left") {
    if (index === 0) return onClose()
    page.value = props.pages[index - 1]
  }

  next.value = index === props.pages.length - 1 ? "Close" : "Next"
}

const onClose = () => {
  emit("close")
}

// Watchers
watch(page, () => {
  changePage(page.value)
})

// Lifecycle Hooks
onMounted(() => {
  page.value = props.default
})

return { __sfc: true,props, emit, next, _next, back, _back, saved, saving, page, _timeout, save, applySaving, changePage, pageIndex, onChangePage, onClose }
}

})